import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-enfermagem`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create: (id, queryParms = {}) => {

            return repository.get(`${baseUrl}/${id}/create?${urlUtil.serialize(queryParms)}`)
        },
        store: (params) => {
            return repository.post(`${baseUrl}`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        },
        storeFaaAssinada: (id, params) => {
            return repository.post(`${baseUrl}/${id}/store-faa-assinada`, params)
        },
        download: (route) => {
            return repository.get(route, { responseType: "arraybuffer" })
        }
    }
}